// Typed reads only: reuse server-issued tokens and existing authorization.
export function pagePayload(result, offset) {
  if (!Number.isInteger(offset) || offset < 0 || offset > 10000 || offset % 25) throw new Error('Unsupported page offset. Narrow the query before exporting.');
  if (result.page_operation === 'migration_approval' && result.migration_patient_id) return {operation:'migration_approval', patient_id:result.migration_patient_id, offset};
  if (!result.query_token) throw new Error('This result cannot be paged. Ask the question again.');
  return {operation:'agent_execute', query_token:result.query_token, offset};
}
export function patientId(result, row) {
  if (result.review_summary?.action !== 'list') return null;
  const key = result.columns.find(c => result.column_labels?.[c] === 'patients · patient id' || c === 'patients.patient_id');
  const id = key && row[key];
  return /^\d+$/.test(String(id ?? '')) ? String(id) : null;
}
export function validatePage(data, initial) {
  if (data?.phase !== 'results' || data.kind !== 'multi_agent' || !Array.isArray(data.rows) || !Array.isArray(data.columns) || JSON.stringify(data.columns) !== JSON.stringify(initial.columns) || data.source !== initial.source || data.scope !== initial.scope || JSON.stringify(data.column_labels) !== JSON.stringify(initial.column_labels)) throw new Error('The result or access scope changed. Ask the question again before exporting.');
  return data;
}
export async function collectResultRows(initial, fetchPage, signal, onProgress = () => {}) {
  if (!initial.has_more && (initial.offset ?? 0) === 0) return initial.rows;
  let cursor = initial, offset = 0, rows = [], seen = new Set();
  for (let pages = 0; pages < 401; pages++) {
    if (signal?.aborted) throw new Error('Export cancelled.');
    if (seen.has(offset)) throw new Error('Repeated page offset. No file downloaded.');
    seen.add(offset);
    const page = validatePage(await fetchPage(pagePayload(cursor, offset), signal), initial);
    if (page.offset !== offset || (page.count !== undefined && initial.count !== undefined && page.count !== initial.count)) throw new Error('Matching records changed during export. Please retry.');
    rows.push(...page.rows); onProgress(rows.length);
    if (!page.has_more) return rows;
    if (!page.rows.length || !Number.isInteger(page.next_offset) || page.next_offset <= offset) throw new Error('Invalid next page. No file downloaded.');
    offset = page.next_offset; cursor = page;
  }
  throw new Error('Export exceeds the supported page range. Narrow the query.');
}
export function workbookCells(result, rows) {
  // Strings remain string cells in XLSX, including values beginning with =, +, - or @.
  return [result.columns.map(c => result.column_labels?.[c] || c), ...rows.map(row => result.columns.map(c => row[c] == null ? '' : String(row[c])))];
}
